import { render, staticRenderFns } from "./ToggleUserFamilyVerifyConfirmationDialog.vue?vue&type=template&id=0b87b61a"
import script from "./ToggleUserFamilyVerifyConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./ToggleUserFamilyVerifyConfirmationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports